<script lang="ts" setup>
import { SrcSet } from '~/composables/useSrcSet'

export interface ImageGridItemProps {
    image: Image
    alt?: string
    index?: number
}
const props = defineProps<ImageGridItemProps>()

const imageSrc = computed((): SrcSet | undefined => useSrcSet(props.image.path))
</script>
<template>
  <img
    :src="imageSrc?.src"
    :srcset="imageSrc?.srcSet"
    :width="220"
    :height="147"
    class="w-100 mb-md-3 mb-md-6 h-auto rounded"
    :class="{
      'mt-6 mt-md-12': index === 0,
      'd-none d-md-inline-block': index !== 1,
      'd-inline-block': index === 1,
    }"
    loading="lazy"
    decoding="async"
    :alt="props.alt"
  >
</template>
